// extracted by mini-css-extract-plugin
module.exports = {"close":"SnackbarNotifier_close__hllYw"};